<template>
  <div class="container">
    <h1 class="py-4">アプリユーザデータ詳細</h1>
    <div v-if="show" :key="key">
      <div v-if="loading">loading...</div>
      <div v-if="!loading" class="table-responsive">
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">ログインID</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.login_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">携帯電話番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.mobile }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">生年月日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.birthday }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">性別</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.sex }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">フレンドコード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.friend_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">ニックネーム</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.nickname }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">popinfoID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05 ml05">{{ userData.popinfoID }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">メールアドルレス</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.mail_address }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">メール通知受信</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.receive_mail }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">PUSH通知受信</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.receive_notif }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">デバイス機種名</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.device_model_name }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">デバイスOS種別</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.device_os_type }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">デバイスOSバージョン</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.device_os_version }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">パスワード試行回数</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.password_trial_count }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">ログインロック日時</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.login_lock_date }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">ウォレットサーブスID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.wallet_service_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">アプリユーザID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.application_user_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">提携先会員ID</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.partner_member_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">利用規約ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.agreement_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">規約同意日時</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.agreement_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">おたすけ利用規約ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.agreement_otasuke_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">規約同意日時</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.agreement_otasuke_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">おたすけステータス</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.otasuke_status }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">おたすけ精算回数</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.otasuke_settlement_count }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">KYC利用規約ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.agreement_kyc_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">規約同意日時</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.agreement_kyc_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">デフォルト決算手段ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.default_payment_method_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">代表契約決算手段ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ userData.rep_contract_settlement_method_id }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">アカウントロック状態</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.account_lock_status }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">ステータス</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.status }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">作成管理ユーザID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.management_user_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">最終更新管理ユーザID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ userData.last_update_management_user_id }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">作成日時</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.created_at }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">最終更新日時</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ userData.updated_at }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">退会時発行コード</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.withdraw_execution_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">退会理由</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.withdraw_reason }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">退会日時</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ userData.withdraw_date }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="show2">
          <h4 class="py-4">c.choy-san会員情報</h4>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container175 d-flex">
                <p class="ml05">UID</p>
              </div>
              <div class="greyBorder container825 d-flex">
                <p class="mr05 ml00">{{ choysanData.UID }}</p>
              </div>
            </div>
            <div
              v-for="(data, name, index) in this.choysanBisData"
              :key="index"
              class="d-flex datacontainer flex-nowrap"
            >
              <div class="grey-background greyBorderNoTop property d-flex">
                <p>{{ name }}</p>
              </div>
              <div class="greyBorderNoTop value d-flex">
                <p>{{ data }}</p>
              </div>
            </div>
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorderNoTop container175 d-flex">
                <p class="ml05">リンク元URL</p>
              </div>
              <div class="greyBorderNoTop container825 d-flex">
                <p class="mr05 ml00">{{ choysanData.source }}</p>
              </div>
            </div>
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorderNoTop container175 d-flex">
                <p class="ml05">パートナID</p>
              </div>
              <div class="greyBorderNoTop container825 d-flex">
                <p class="mr05 ml00">{{ choysanData.pid }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorderNoTop property d-flex">
                <p>在留資格</p>
              </div>
              <div class="greyBorderNoTop value d-flex">
                <p>{{ choysanData.zairyuuShikaku }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorderNoTop property d-flex">
                <p>在留資格（その他）</p>
              </div>
              <div class="greyBorderNoTop value d-flex">
                <p>{{ choysanData.zairyuOther }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import sex from "@/constants/SexEnum";
import countries from "@/constants/CountriesEnum";
import prefs from "@/constants/PrefsEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";

export default {
  name: "ApplicationUserDataDetails",
  mixins: [utils, master, sex, countries, prefs],
  data() {
    return {
      userData: [],
      applicationUserId: "",
      show: false,
      show2: false,
      loading: true,
      unformatedChoysanData: [],
      choysanData: [],
      db: firebase.firestore(),
    };
  },
  created: function() {
    this.applicationUserId = this.$route.query.applicationUserId.toString();
    this.loadUserData();
  },
  methods: {
    init() {
      this.show = false;
      this.key = this.key ? 0 : 1;
    },
    async loadUserData() {
      this.init();
      const snapshot = await this.db
        .collection("applicationUsers")
        .where("application_user_id", "==", this.applicationUserId)
        .limit(1)
        .get();
      if (snapshot.docs[0] !== undefined) {
        const data = snapshot.docs[0].data();

        this.userData = data;
        let sexText = this.sexOptions.find((e) => {
          return e.value == this.userData.sex;
        });
        if (sexText !== undefined) {
          this.userData.sex = sexText.display;
        }

        let notifMailText = this.notificationOptions.find((e) => {
          return e.value == this.userData.receive_mail;
        });
        if (notifMailText !== undefined) {
          this.userData.receive_mail = notifMailText.display;
        }

        let notifPushText = this.notificationOptions.find((e) => {
          return e.value == this.userData.receive_notif;
        });
        if (notifPushText !== undefined) {
          this.userData.receive_notif = notifPushText.display;
        }

        let statusText = this.statusOptions.find((e) => {
          return e.value == this.userData.status;
        });
        if (statusText !== undefined) {
          this.userData.status = statusText.display;
        }

        let otasukeStatusText = this.otasuke_statusOptions.find((e) => {
          return e.value == this.userData.otasuke_status;
        });
        if (statusText !== undefined) {
          this.userData.otasuke_status = otasukeStatusText.display;
        }

        let accountLockStatusText = this.lockStatusOptions.find((e) => {
          return e.value == this.userData.account_lock_status;
        });

        if (accountLockStatusText !== undefined) {
          this.userData.account_lock_status = accountLockStatusText.display;
        }

        let withdrawReasonText = this.withdrawReasonOptions.find((e) => {
          return e.value == this.userData.withdraw_reason;
        });

        if (withdrawReasonText !== undefined) {
          this.userData.withdraw_reason = withdrawReasonText.display;
        }

        let mobile = data.mobile;
        if (mobile !== undefined && mobile !== "") {
          await this.db
            .collection("users")
            .where("phone", "==", mobile.toString())
            .where("status", "==", "1")
            .limit(1)
            .get()
            .then((query) => {
              if (!query.empty) {
                let choysanDoc = query.docs[0];
                for (const [key, value] of Object.entries(choysanDoc.data())) {
                  if (this.fields[key] == undefined)
                    this.unformatedChoysanData[key] = value;
                  else if (
                    key == "created_at" ||
                    key == "updated_at" ||
                    key == "telephone_0" ||
                    key == "mobile_0"
                  ) {
                    // do nothing, don't add
                  } else if (key == "sex") {
                    this.unformatedChoysanData[this.fields[key]] = this.sex[
                      value
                    ];
                  } else if (key == "country_code") {
                    this.unformatedChoysanData[
                      this.fields[key]
                    ] = this.countries.find(
                      (element) => element.code == value
                    ).name;
                  } else if (key == "pref_code") {
                    this.unformatedChoysanData[
                      this.fields[key]
                    ] = this.prefs.find(
                      (element) => element.code == value
                    ).name;
                  } else if (key == "birthday") {
                    this.unformatedChoysanData[
                      this.fields[key]
                    ] = this.formatDateTime(value.toDate());
                  } else this.unformatedChoysanData[this.fields[key]] = value;
                }
                this.unformatedChoysanData["UID"] = choysanDoc.id;
                this.choysanData = this.copyFields(this.unformatedChoysanData, [
                  "first_name_en",
                  "last_name_en",
                  "middle_name_en",
                  "phone",
                  "birthday",
                  "sex",
                  "country_code",
                  "pref_code",
                  "nickname",
                  "source",
                  "redirect",
                  "zairyuuShikaku",
                  "zairyuOther",
                  "status",
                ]);
                this.show2 = true;
              }
            });
        }
        this.loading = false;
        this.show = true;
      } else {
        this.$router.push({ name: "Home" });
      }
    },
  },
};
</script>
